import { RouteRecordRaw } from 'vue-router';
import { TestContentPage } from '@/pages/test-content';

export const routeName = 'TestContentPage';

export const route: RouteRecordRaw = {
  path: 'conteudo-prova',
  name: routeName,
  component: TestContentPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Conteúdo da Prova',
    permissions: [{ action: 'manage', subject: 'ContentProof' }],
  },
};

